import { z } from 'zod';

const RELEASE_MANIFEST_PATH = '/release-manifest.json';

const clientReleaseManifestSchema = z.object({
  releaseTag: z.string(),
  releasedAt: z.string(),
});

export async function fetchClientReleaseManifest(fetchReleaseManifest = fetch) {
  try {
    const response = await fetchReleaseManifest(`${RELEASE_MANIFEST_PATH}?ts=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!response.ok) return null;

    const manifest: unknown = await response.json();
    const parsedManifest = clientReleaseManifestSchema.safeParse(manifest);
    if (!parsedManifest.success) return null;

    return parsedManifest.data;
  } catch {
    return null;
  }
}
